// extracted by mini-css-extract-plugin
export default {"news":"Newsfp_news__KH7g3","newsHeader":"Newsfp_newsHeader__TEdmi","newsContent":"Newsfp_newsContent__Tj97N"};